import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAppSelector } from '../../app/hooks';

export function RequireAuth({ children }: { children: JSX.Element }) {
  const location = useLocation();

  const isAuthInitialized = useAppSelector(state => state.auth.isAuthInitialized);
  const jwtToken = useAppSelector(state => state.auth.jwtToken);
  const user = useAppSelector(state => state.auth.user);
  const getProfileError = useAppSelector(state => state.auth.getProfile.error);

  // Wait for auth to be initialized
  if (!isAuthInitialized) {
    return null;
  }

  // No token, redirect to login
  if (!jwtToken) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Wait for profile to load
  if (!user && !getProfileError) {
    return null;
  }

  return children;
}
